import dJSON from 'dirty-json';

const moduleSelector = '.ex-product .tab-wrapper.specs';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const delivery = dJSON.parse(query.delivery);

      delivery.forEach((item) => {
        query.querySelector('.delivery-wrapper').insertAdjacentHTML('beforeend', /* html */ `
        <p class="${item.cat}">${item.delivery}</p>
        `);
      });

      const returns = dJSON.parse(query.returns);

      returns.forEach((item) => {
        query.querySelector('.returns-wrapper').insertAdjacentHTML('beforeend', /* html */ `
          <p class="${item.cat}">${item.returns}</p>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * look for latest category and only display that information in delivery and returns
 */
(() => {
  const query = document.querySelector('.ex-product');
  if (!query) return;

  const delivery = query.querySelectorAll('.delivery-wrapper');
  const returns = query.querySelectorAll('.returns-wrapper');
  const deliveryItems = Array.from(delivery).map((wrapper) => Array.from(wrapper.querySelectorAll('p'))).reduce((acc, items) => acc.concat(items), []);
  const returnsItems = Array.from(returns).map((wrapper) => Array.from(wrapper.querySelectorAll('p'))).reduce((acc, items) => acc.concat(items), []);
  const allItems = [...deliveryItems, ...returnsItems];
  const breadcrumb = document.querySelector('.breadcrumb');

  let breadcrumbItems = Array.from(breadcrumb.querySelectorAll('li'));

  // Reverse breadcrumbItems so we can loop backwards
  breadcrumbItems = breadcrumbItems.reverse();

  function hideAllCategories() {
    allItems.forEach((item) => {
      item.style.display = 'none';
    });
  }

  // Function to show a category
  function showCategory(category) {
    hideAllCategories();

    const matchedItems = allItems.filter((item) => item.classList.contains(category));

    if (matchedItems.length) {
      matchedItems.forEach((item) => {
        item.style.display = 'block';
      });
      return true;
    }
    return false;
  }

  // Check breadcrumbs from most recent to oldest, stop when a match is found
  const matchFound = breadcrumbItems.some((breadcrumbItem) => {
    const category = breadcrumbItem.textContent.trim();

    return showCategory(category);
  });

  // If no match was found after checking all breadcrumbs, show default text
  if (!matchFound) {
    showCategory('default');
  }
})();
